module.exports = __webpack_public_path__ + "17bd6cb5ebc7f9c1e6263ea128cb9330.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/assets/perspective_icon.svg
 ** module id = 643
 ** module chunks = 0
 **/